let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("82QsP"), load("gJRFC")]).then(() => parcelRequire('bQl5d'));